import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import "./index.css";
import  {AuthProvider}  from  "./login/context/AuthProvider"
import { SettingsProvider } from './Navbar/settingsContext';



const rootElement = document.getElementById("root")
const root = ReactDOM.createRoot(rootElement as HTMLElement)


//const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <AuthProvider>
        <SettingsProvider>
            <App />
        </SettingsProvider>
    </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
